<template>
  <div class="asso-team-portal w-100">
    <div v-if="showFieldsLoader" class="products-list-shim bordered-loader">
      <content-placeholders :rounded="true">
        <content-placeholders-img />
        <content-placeholders-heading />
        <content-placeholders-img />
        <content-placeholders-heading />
        <content-placeholders-img />
      </content-placeholders>
    </div>

    <!-- OPTIMIZED TEMPLATE - Avoid multiple function calls -->
    <div v-if="scheduleTables.length > 0 && !showFieldsLoader">
      <div
        v-for="(table, tableIndex) in scheduleTables"
        :key="tableIndex"
        class="mb-4"
      >
        <div :ref="'table-' + getDateForComparison(table.date)">
          <h5 class="field-date mb-3">{{ table.formattedDate }}</h5>
          <div class="pool-table-container">
            <table class="schedule-table">
              <thead>
                <tr>
                  <th class="field-header">Time</th>
                  <th
                    v-for="field in table.fields"
                    :key="field.id"
                    class="field-header"
                  >
                    {{ field.field_name }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(timeSlot, timeIndex) in table.timeSlots"
                  :key="timeIndex"
                >
                  <td class="field-cell">
                    <strong>{{ timeSlot.time }}</strong>
                  </td>
                  <td
                    v-for="field in table.fields"
                    :key="field.id"
                    class="field-cell"
                    @dragover.prevent
                    :class="{
                      assigned: getAssignedGame(
                        field.id,
                        timeSlot.time,
                        getDateForComparison(table.date)
                      ),
                      invalid: !isDateWithinTournamentRange(table.date),
                      available:
                        !getAssignedGame(
                          field.id,
                          timeSlot.time,
                          getDateForComparison(table.date)
                        ) && isDateWithinTournamentRange(table.date),
                      'current-division':
                        getAssignedGame(
                          field.id,
                          timeSlot.time,
                          getDateForComparison(table.date)
                        )?.division_id === selectedTournament.id,
                      'other-division':
                        getAssignedGame(
                          field.id,
                          timeSlot.time,
                          getDateForComparison(table.date)
                        )?.division_id !== selectedTournament.id,
                    }"
                    :style="
                      getAssignedGame(
                        field.id,
                        timeSlot.time,
                        getDateForComparison(table.date)
                      )
                        ? getDivisionStyle(
                            getAssignedGame(
                              field.id,
                              timeSlot.time,
                              getDateForComparison(table.date)
                            ).division
                          )
                        : {}
                    "
                  >
                    <!-- Assigned Game (shown regardless of date validity) -->
                    <div
                      v-if="
                        assignedGameFor(field.id, timeSlot.time, table.date)
                      "
                      class="assigned-game-container"
                      :title="
                        assignedGameFor(field.id, timeSlot.time, table.date)
                          .division_id == selectedTournament.id
                          ? 'Drag this game'
                          : ''
                      "
                      :draggable="
                        assignedGameFor(field.id, timeSlot.time, table.date)
                          .division_id == selectedTournament.id
                      "
                      :style="{
                        cursor:
                          assignedGameFor(field.id, timeSlot.time, table.date)
                            .division_id == selectedTournament.id
                            ? 'grab'
                            : 'not-allowed',
                        userSelect:
                          assignedGameFor(field.id, timeSlot.time, table.date)
                            .division_id == selectedTournament.id
                            ? 'auto'
                            : 'none',
                      }"
                    >
                      <div class="game-info">
                        <div class="teams-names teams-names2">
                          <template
                            v-if="
                              assignedGameFor(
                                field.id,
                                timeSlot.time,
                                table.date
                              )
                            "
                          >
                            <template
                              v-if="
                                assignedGameFor(
                                  field.id,
                                  timeSlot.time,
                                  table.date
                                ).game_type === 2
                              "
                            >
                              #{{
                                assignedGameFor(
                                  field.id,
                                  timeSlot.time,
                                  table.date
                                ).game_name || "Unnamed Game"
                              }}
                            </template>
                            <template v-else>
                              #{{
                                assignedGameFor(
                                  field.id,
                                  timeSlot.time,
                                  table.date
                                )?.teamA_data?.team_sr_no || "TBD"
                              }}
                              <span class="vs-text">vs</span>
                              #{{
                                assignedGameFor(
                                  field.id,
                                  timeSlot.time,
                                  table.date
                                )?.teamB_data?.team_sr_no || "TBD"
                              }}
                            </template>
                          </template>
                        </div>
                        <div class="division-names">
                          {{
                            assignedGameFor(field.id, timeSlot.time, table.date)
                              ?.division
                          }}
                        </div>
                      </div>
                    </div>

                    <div v-else class="availability-status invalid"></div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "AssociationFieldGridInfo",
  data() {
    return {
      tournamentsData: [],
      selectedTournament: {},
      scheduled: {},
      tournament_time: "",
      startTime: "08:00 AM",
      endTime: "05:00 PM",
      selectedFields: [],
      scheduleData: [],
      parkField: [],
      allFields: [],
      searchQuery: "",
      eventId: null,
      association_id: 0,
      events: {},
      eventName: "",
      showEventHeadingLoader: 0,
      showFieldsLoader: 1,
      startDate: null,
      endDate: null,
      fieldAssignments: [],
      summaryData: 0,
      divisionColorMap: {},
      usedColors: new Set(),
      divisionPage: 1,
    };
  },
  computed: {
    assignedGamesMap() {
      const map = {};
      this.scheduleData.forEach((game) => {
        if (game.assignedFieldId && game.assignedTime && game.assignedDate) {
          const key = `${game.assignedFieldId}-${game.assignedTime}-${game.assignedDate}`;
          map[key] = game;
        }
      });
      return map;
    },
    scheduleTables() {
      if (
        !this.startDate ||
        !this.endDate ||
        !this.startTime ||
        !this.endTime ||
        !this.tournament_time ||
        this.allFields.length === 0
      ) {
        return [];
      }

      const tables = [];
      const start = new Date(this.startDate);
      const end = new Date(this.endDate);

      for (
        let date = new Date(start);
        date <= end;
        date.setDate(date.getDate() + 1)
      ) {
        const currentDate = new Date(date);
        const timeSlots = this.generateTimeSlots(
          this.startTime,
          this.tournament_time,
          this.endTime
        );

        tables.push({
          date: currentDate,
          formattedDate: this.formatTableDate(currentDate),
          timeSlots,
          fields: this.selectedFields,
        });
      }

      return tables;
    },
  },
  async mounted() {
    await this.TournamentsDetailData();
    await this.getEventGamesSchedule();
    this.getParkField();
  },
  methods: {
    assignedGameFor(fieldId, time, date) {
      return this.getAssignedGame(
        fieldId,
        time,
        this.getDateForComparison(date)
      );
    },

    assignColorsToDivisions() {
      const staticColors = ["#DFFFEA", "#FFFAEA"]; // greenish, bluish
      const usedColors = new Set(staticColors);
      const uniqueDivisions = [
        ...new Set(this.scheduleData.map((game) => game.division)),
      ];

      uniqueDivisions.forEach((division, index) => {
        if (!this.divisionColorMap[division]) {
          if (index < staticColors.length) {
            this.divisionColorMap[division] = staticColors[index];
          } else {
            let newColor;
            do {
              newColor = this.getRandomPastelColor();
            } while (usedColors.has(newColor)); // avoid duplicates

            usedColors.add(newColor);
            this.divisionColorMap[division] = newColor;
          }
        }
      });
    },

    getRandomPastelColor() {
      const hue = Math.floor(Math.random() * 360);
      return `hsl(${hue}, 70%, 85%)`; // pastel-like
    },

    getDivisionStyle(division) {
      const color = this.divisionColorMap[division];
      return color ? { backgroundColor: color } : {};
    },

    getAssignedGame(fieldId, time, date) {
      const key = `${fieldId}-${time}-${date}`;
      return this.assignedGamesMap[key] || null;
    },

    assignGameToSlot(game, field, timeSlot, date) {
      const assignedIndex = this.scheduleData.findIndex(
        (g) => g.db_id === game.db_id
      );
      if (assignedIndex !== -1) {
        const originalGame = this.scheduleData[assignedIndex];
        this.$set(originalGame, "assignedFieldId", field.id);
        this.$set(originalGame, "assignedFieldName", field.field_name);
        this.$set(originalGame, "assignedTime", timeSlot.time);
        this.$set(originalGame, "assignedDate", date);

        this.fieldAssignments = this.fieldAssignments.filter(
          (assignment) => assignment.game.db_id !== game.db_id
        );

        this.fieldAssignments.push({
          fieldId: field.id,
          fieldName: field.field_name,
          time: timeSlot.time,
          date: date,
          game: game,
        });

        this.$forceUpdate();
      } else {
        console.warn("Game not found in scheduleData");
      }
    },

    getDateForComparison(date) {
      if (date instanceof Date) {
        // Use local time instead of UTC
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      }
      return date;
    },

    generateTimeSlots(startTime, intervalMinutes, endTime) {
      const slots = [];

      // Helper function to convert "HH:MM AM/PM" → total minutes
      const convertToMinutes = (timeStr) => {
        const [time, period] = timeStr.split(" ");
        const [hours, minutes] = time.split(":").map(Number);

        let hour24 = hours;
        if (period === "PM" && hours !== 12) hour24 += 12;
        if (period === "AM" && hours === 12) hour24 = 0;

        return hour24 * 60 + minutes;
      };

      const startMinutes = convertToMinutes(startTime);
      const endMinutes = convertToMinutes(endTime); // ⬅️ using dynamic endTime

      for (
        let currentMinutes = startMinutes;
        currentMinutes < endMinutes;
        currentMinutes += intervalMinutes
      ) {
        const hour = Math.floor(currentMinutes / 60);
        const minute = currentMinutes % 60;

        const displayHour = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;
        const displayPeriod = hour >= 12 ? "PM" : "AM";
        const timeString = `${displayHour
          .toString()
          .padStart(2, "0")}:${minute
          .toString()
          .padStart(2, "0")} ${displayPeriod}`;

        slots.push({
          time: timeString,
          minutes: currentMinutes,
        });
      }

      return slots;
    },

    formatTableDate(date) {
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return date.toLocaleDateString("en-US", options);
    },

    getParkField(searchQuery) {
      // this.isLoadingField = true;
      this.showFieldsLoader = 1;
      axios
        .get(
          `${process.env.VUE_APP_API_URL}getAllEventParkFields?event_id=${
            this.eventId
          }&search=${searchQuery || ""}`
        )
        .then((response) => {
          const parks = response.data.data.parks || [];

          // Flatten all fields and filter out "Add field"
          const allFields = parks
            .flatMap((park) => park.fields || [])
            .filter(
              (field) =>
                field.field_name &&
                field.field_name.toLowerCase() !== "add field"
            );

          this.allFields = allFields;
          this.selectedFields = [...allFields];
          // this.isLoadingField = false;
          this.showFieldsLoader = 0;
        });
    },

    async TournamentsDetailData() {
      var url = window.location.pathname;
      var segment_array = url.split("/");
      var eventGuid = segment_array.pop();
      this.showEventHeadingLoader = 1;
      this.showLoaderTournament = 1;

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}event/tournamentListForAdminEvents?page=${this.divisionPage}`,
          { event_guid: eventGuid }
        );

        if (response.data.statusCode === 200) {
          const tournamentResponse = response.data.data.eventTournaments.data;
          this.events = response.data.data.teamEventData;
          this.startDate = response.data.data.teamEventData.exactStartDate;
          this.endDate = response.data.data.teamEventData.exactEndDate;
          this.eventId = response.data.data.teamEventData.id;
          this.eventName = response.data.data.teamEventData.eventName;
          this.startTime = response.data.data.teamEventData.exactStartTime;
          this.endTime = response.data.data.teamEventData.exactEndTime;
          this.tournament_time = Number(
            response.data.data.teamEventData?.time_interval ?? 30
          );
          this.association_id =
            response.data.data?.user_association_role?.association_id;

          if (this.divisionPage > 1) {
            const combined = [...this.tournamentsData, ...tournamentResponse];

            // Filter unique by `guid`
            const uniqueTournaments = combined.filter(
              (tournament, index, self) =>
                index === self.findIndex((t) => t.guid === tournament.guid)
            );

            this.tournamentsData = uniqueTournaments;
          } else {
            this.tournamentsData = tournamentResponse;
          }
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });

          this.showLoader = 0; // Hide loader
        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoaderTournament = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.showLoaderTournament = 0;
      } finally {
        this.showEventHeadingLoader = 0;
        this.showLoaderTournament = 0;
        this.$root.$emit("divisionPaginationLoaded");
      }
    },

    async getEventGamesSchedule() {
      var url = window.location.pathname;
      var segment_array = url.split("/");
      var eventGuid = segment_array.pop();
      this.showEventHeadingLoader = 1;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}tournaments/getEventGamesSchedule`,
          { params: { event_guid: eventGuid } }
        );

        if (response.data.statusCode === 200) {
          this.scheduleData = response.data.data.schedule;
          this.summaryData = response.data.data.summary;

          // Assign each game to its slot
          this.scheduleData.forEach((game) => {
            if (
              game.assignedFieldId &&
              game.assignedTime &&
              game.assignedDate
            ) {
              const field = {
                id: game.assignedFieldId,
                field_name: game.assignedFieldName,
              };

              const timeSlot = {
                time: game.assignedTime,
              };

              this.assignGameToSlot(game, field, timeSlot, game.assignedDate);
            }
          });
          this.assignColorsToDivisions();
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
      } finally {
        this.$root.$emit("divisionPaginationLoaded");
        this.showEventHeadingLoader = 0;
      }
    },

    isDateWithinTournamentRange(date) {
      if (!this.selectedTournament) return false;

      const start = new Date(this.selectedTournament.startDateForField);
      const end = new Date(this.selectedTournament.endDateForField);

      const cellDate = new Date(date);

      // Remove time part for comparison
      start.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);
      cellDate.setHours(0, 0, 0, 0);

      return cellDate >= start && cellDate <= end;
    },
  },
};
</script>
